import store from '@/store';

export default () => {
    return store.dispatch('get_is_travel_esim_enabled').then(() => {
        const is_travel_esim_enabled = store.getters.is_travel_esim_enabled;

        return {
            allow: is_travel_esim_enabled,
            redirect: { name: 'not-found' },
        }
    })
};
